import styled from 'styled-components';
import { NavLink as NavLinkCore } from 'react-router-dom';
import * as palette from 'config';

export const NavLink = styled(NavLinkCore)`
    text-decoration: none;
    display: initial;
    transition: background 0.2s ease;

    &.active {
        background: ${({ theme }) => theme.palette.primary.main};
    }
    &:hover {
        background: ${({ theme }) => theme.palette.grey[500]};
    }
`;

export const Container = styled.div`
    line-height: ${palette.FONT_SIZE_ENORMOUS};
    font-size: ${palette.FONT_SIZE_LARGE};
    color: ${({ theme }) => theme.palette.common.white};
    display: flex;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: normal;
    align-items: center;

    svg {
        min-width: 20px;
    }
`;

export const Title = styled.span`
    line-height: ${palette.FONT_SIZE_ENORMOUS};
    font-size: ${palette.FONT_SIZE_LARGE};
    color: ${({ theme }) => theme.palette.common.white};
    align-items: center;
    justify-content: center;
    padding-left: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
